var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5162 34.8712C27.0672 34.8712 34.8098 27.1181 34.8098 17.5542C34.8098 7.99027 27.0672 0.237183 17.5162 0.237183C7.96525 0.237183 0.222656 7.99027 0.222656 17.5542C0.222656 27.1181 7.96525 34.8712 17.5162 34.8712Z",
    fill: "#2997D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43851 17.012L23.8775 11.0544C24.595 10.7969 25.2177 11.2306 24.9875 12.3151L22.3614 24.7182C22.1651 25.5993 21.6439 25.8094 20.9129 25.396L16.9127 22.4409L14.9837 24.3048C14.7671 24.5217 14.5911 24.6979 14.1782 24.6979L14.4625 20.6177L21.8808 13.9078C22.2057 13.6232 21.8063 13.4605 21.3799 13.7452L12.2086 19.5197L8.25576 18.2862C7.39616 18.0083 7.37585 17.4254 8.43851 17.012Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tg-icon.1ba1df804fb7a5bf8b0a9101116f649f.svg";
export { ForwardRef as ReactComponent };